export const OWNER_CLASS = {
  0: 'home',
  1: 'away',
  2: 'draw',
};
export const HOME_CARD = 0;
export const AWAY_CARD = 1;

export const BET_TYPES = {
  home: 0,
  away: 1,
  draw: 2,
};

export const BET_TYPES_NAMES = {
  0: 'homeWin',
  1: 'awayWin',
  2: 'draw',
};

export const BET_TYPES_LETTERS = {
  0: 'H',
  1: 'A',
  2: 'D',
};

export const OWNER_BET_TYPE_T_KEYS = {
  homeWin: 'HOMEI',
  awayWin: 'AWAY',
  draw: 'DRAW',
};

export const BET_TYPES_ODDS = {
  0: 2,
  1: 2,
  2: 12,
};

export const BET_NAMES_BY_TYPES = {
  homeWin: 0,
  awayWin: 1,
  draw: 2,
};

export const OWNER_T_KEYS = {
  HomeWin: 'HOMEI',
  AwayWin: 'AWAY',
  Draw: 'DRAW',
};

export const CHIPS_VIEW_TYPES = [
  {
    betType: BET_TYPES.home,
    betName: OWNER_T_KEYS.HomeWin,
    position: 'left',
    odd: '1:1',
  },
  {
    betType: BET_TYPES.draw,
    betName: OWNER_T_KEYS.Draw,
    position: 'center',
    odd: '11:1',
  },
  {
    betType: BET_TYPES.away,
    betName: OWNER_T_KEYS.AwayWin,
    position: 'right',
    odd: '1:1',
  },
];
